export * from './AutomaticCarousel';
